import React from 'react';
import { Card, CardContent, Typography, Stack, Box } from '@mui/material';

const InvoiceStatsCard = ({ label, stats, icon: Icon, hero }) => (
  <Card
    elevation={0}
    sx={{
      minHeight: hero ? 220 : 160,
      height: '100%',
      borderRadius: 4,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'relative',
      overflow: 'visible',
      boxShadow: 'none',
      background: 'background.paper',
      color: 'text.primary',
      p: 0,
      border: '1px solid',
      borderColor: 'divider',
    }}
  >
    {/* Neutral left accent */}
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: hero ? 24 : 18,
        bottom: hero ? 24 : 18,
        width: hero ? 6 : 4,
        borderRadius: '8px',
        bgcolor: 'action.selected',
      }}
    />
    <CardContent sx={{ pl: hero ? 5 : 3.5, pr: hero ? 4 : 2.5, py: hero ? 3 : 2, height: '100%' }}>
      <Stack direction="row" alignItems="center" spacing={hero ? 3 : 2} sx={{ height: '100%' }}>
        {Icon && (
          <Box
            sx={{
              bgcolor: 'action.selected',
              color: 'text.primary',
              borderRadius: '50%',
              width: hero ? 72 : 56,
              height: hero ? 72 : 56,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: hero ? 44 : 34,
              mr: 1,
            }}
          >
            <Icon fontSize="inherit" />
          </Box>
        )}
        <Box flex={1}>
          <Typography variant={hero ? 'h5' : 'subtitle2'} color="text.secondary" gutterBottom fontWeight={700} fontSize={hero ? 22 : 16}>
            {label}
          </Typography>
          <Stack direction="row" spacing={hero ? 5 : 3} alignItems="center">
            <Stack>
              <Typography variant={hero ? 'h3' : 'h4'} fontWeight="bold" color="text.primary">
                {stats.allTime}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                All Time
              </Typography>
            </Stack>
            <Stack>
              <Typography variant={hero ? 'h5' : 'h6'} fontWeight="bold" color="text.primary">
                {stats.last7Days}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Last 7 Days
              </Typography>
            </Stack>
            <Stack>
              <Typography variant={hero ? 'h5' : 'h6'} fontWeight="bold" color="text.primary">
                {stats.today}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Today
              </Typography>
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </CardContent>
  </Card>
);

export default InvoiceStatsCard;
